import React, { Component, PropTypes } from 'react'
import { Colors, Metrics, Fonts } from '../../Themes'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import Filter from '../../svg-icons/Filter'
import CloseIcon from '../../svg-icons/CloseIcon'
import ThemeContainer from '../../components/ThemeContainer'
import Button from '../Button'

const Container = styled.div`
  display: none;
  @media screen and (max-width: ${Metrics.breakpoints.tablet}) {
    display: ${props => (props.isAdmin ? 'none' : 'block')};
    height: ${Metrics.components.mobileSearchBarSize};
  }
`

const Forms = styled.div`
  pointer-events: none;
  opacity: 0;
  height: calc(100% - 40px);
  &.open {
    pointer-events: all;
    opacity: 1;
    transition: ease-in all 0.2s;
    transition-delay: 0.3s;
  }
`

const FiltersContainer = styled.div`
  transition: ease-out all 0.5s;
  background-color: white;
  position: absolute;
  height: 40px;
  width: calc(100vw - 30px);
  border: ${Metrics.borders.default};
  z-index: 2;
  left: 15px;
  top: calc(${Metrics.components.navbarDefault} + ${Metrics.margins.base});

  &.open {
    transition: ease-in all 0.3s;
    box-shadow: none;
    height: 100vh;
    width: 100vw;
    left: 0;
    top: 0;
  }
`

const ButtonText = styled.div`
  float: left;
  ${Fonts.style.Text};
  margin-top: ${Metrics.margins.tiny};
  font-size: ${Fonts.size.medium};
`

const ButtonIcon = styled.div`
  float: right;
  #filters {
    fill: ${Colors.primary};
  }
`

const FilterButton = styled.div`
  padding: ${Metrics.margins.small};
  &.open {
    transition: ease-in all 0.3s;
    opacity: 0;
    padding: 0;
  }
`

const CloseButton = styled.div`
  height: 40px;
  position: relative;
  svg {
    position: absolute;
    right: ${Metrics.margins.base};
    top: ${Metrics.margins.small};
  }
`

const Apply = styled(Button)`
  text-align: center;
  background: ${Colors.primary};
  color: ${Colors.white};
  float: inherit;
  width: calc(100% - (2 * ${Metrics.components.themeMobileMargins}));
  margin-left: ${Metrics.margins.base};
  margin-right: ${Metrics.margins.base};
  position: absolute;
  bottom: ${Metrics.margins.base};
`

const CustomThemeContainer = styled(ThemeContainer)`
  max-height: calc(100% - 60px);
  overflow-y: scroll;
  padding: 0 ${Metrics.margins.base};
`

class MobileSearchBar extends Component {
  render () {
    const {
      children,
      openModal,
      toggleModal,
      apply,
      clearFilters,
      t,
      isAdmin
    } = this.props
    return (
      <Container className={openModal && 'open'} isAdmin={isAdmin}>
        <FiltersContainer className={openModal && 'open'}>
          <FilterButton onClick={toggleModal} className={openModal && 'open'}>
            <ButtonText>{t('Filter')}</ButtonText>
            <ButtonIcon>
              <Filter />
            </ButtonIcon>
          </FilterButton>
          <Forms className={openModal && 'open'}>
            <CloseButton>
              <CloseIcon onClick={toggleModal} />
            </CloseButton>
            <CustomThemeContainer>
              {children}
              <Button
                secondary
                onClick={clearFilters}
                label={t('Clear All Filters')}
              />
            </CustomThemeContainer>
            <Apply onClick={apply} label={'Apply'} />
          </Forms>
        </FiltersContainer>
      </Container>
    )
  }
}

MobileSearchBar.propTypes = {
  children: PropTypes.node,
  apply: PropTypes.func,
  toggleModal: PropTypes.func,
  openModal: PropTypes.bool,
  clearFilters: PropTypes.func,
  t: PropTypes.func,
  isAdmin: PropTypes.bool
}

export default translate([ 'common', 'search' ], { wait: true })(
  MobileSearchBar
)



// WEBPACK FOOTER //
// ./src/components/SearchBar/MobileSearchbar.js